











































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class'; 
import { mapActions } from 'vuex';


@Component
export default class LayoutMenu extends Vue {
  @Action('security/logout') logout: () => {};
  @Action('product/fetch') refreshProductsObjects(): Promise<any> { return new Promise((a,b)=>{a();}); }
  @Action('order/updateOrders') updateOrders(force: boolean = false): Promise<any> { return new Promise((a,b)=>{a();}); }

  loading: any = {
    orders: 0,
    products: 0
  };

  async refreshOrders() {
    if (this.loading.orders) {
      return;
    }
    this.loading.orders = 1;
    try {
      await this.updateOrders(true);
    } catch (e) {
      // toast or something similar can be used
    } finally {
      this.loading.orders = 0;
    }
  }

  async refreshProducts() {
    if (this.loading.products) {
      return;
    }
    this.loading.products = 1;
    try {
      await this.refreshProductsObjects();
    } catch (e) {
      // toast or something similar can be used
    } finally {
      this.loading.products = 0;
    }
  }
}
